import "./Tasks.css";
import DataTable from "../../../Components/DataTable/DataTable";
import { useNavigate } from "react-router-dom";
import PageHead from "../../../Components/PageHead/PageHead";
import { PublicGet } from "../../../Services/Server";
import Url from "../../../Services/Url";
import User from "../../../Services/User";
import { useState, useEffect } from "react";
import AddTaskWizard from "../../../Modals/AddTaskModal.js/AddTaskWizard";
import AddPendingTaskWizard from "../../../Modals/AddPendingTask/AddTaskWizard";
import Time from "../../../Services/Time";
import { toast } from "react-toastify";

const TaskReader = (rec) => {
	return [
		rec.vesselName,
		rec.jobNumber,
		rec.companyName,
		rec.location,
		Time.getDate(rec.createdAt),
	];
};

const JobReader = (rec) => {
	return [
		rec.vessel,
		rec.equipment,
		rec.company,
		rec.port,
		Time.getDate(rec.createdAt),
	];
};

const TasksView = ({ navoption, ModalAction }) => {
	const trackingCode = User.getCompany().companyTrackingCode;

	const userRoles = User.getRoles();
	const heading = ["Job Number", "Company", "Location", "Started on"];
	const jobHeading = ["Job", "Company", "Location", "Started on"];
	const Navigate = useNavigate();

	const [current, setCurrent] = useState({
		heading: ["Ongoing Tasks", ...heading],
	});
	const [previous, setPrevious] = useState({
		heading: ["Completed Tasks", ...heading],
	});
	const [view, setView] = useState("current");
	const [searchKeyword, setSearchKeyword] = useState("");

	// Choose correct endpoint based on prefix
	const getTaskEndpoint = (trackingCode, state, page) => {
		if (trackingCode.toLowerCase().startsWith("ent-")) {
			return Url.public.getEntCompanyTasks(trackingCode, state, page);
		} else if (trackingCode.toLowerCase().startsWith("mrt-")) {
			return Url.public.getMrtCompanyTasks(trackingCode, state, page);
		} else {
			console.warn(" Invalid tracking code prefix.");
			return null;
		}
	};

	const loadCurrent = (page) => {
		const endpoint = getTaskEndpoint(trackingCode, true, page);
		if (!endpoint) return;

		const searchQuery = searchKeyword
			? `?q=${encodeURIComponent(searchKeyword)}`
			: "";
		PublicGet(endpoint + searchQuery)
			.then((resp) => {
				setCurrent({ ...current, data: resp });
			})
			.catch((err) => {});
	};

	const loadPrevious = (page) => {
		const endpoint = getTaskEndpoint(trackingCode, false, page);
		if (!endpoint) return;

		const searchQuery = searchKeyword
			? `?q=${encodeURIComponent(searchKeyword)}`
			: "";
		PublicGet(endpoint + searchQuery)
			.then((resp) => {
				setPrevious({ ...previous, data: resp });
			})
			.catch((err) => {
				console.error("Error loading previous tasks:", err);
			});
	};

	const loadData = (page) => {
		if (view === "current") loadCurrent(page);
		else if (view === "previous") loadPrevious(page);
	};

	useEffect(() => {
		if (trackingCode) loadData(0);
	}, [view, searchKeyword, trackingCode]);

	const onTaskClick = (e) => {
		PublicGet(Url.taskByTracking(e.id)).then((resp) => {
			Navigate(`${e.id}`, { state: { ...resp, showLeftPanel: false } });
		});
	};

	const flex = [20, 20, 20, 20, 20];
	const btns = navoption.controls();

	const handleTemplate = () => Navigate("MilestoneTemplates");

	const handleAddTask = () => {
		const Options = {
			title: "Add Task",
			element: AddTaskWizard,
			closeModal: (resp) => {
				loadData(0);
				ModalAction.closeModal();
			},
		};
		ModalAction.openModal(Options, "Add Task");
	};

	if (Array.isArray(btns)) {
		btns.forEach((btn) => {
			if (btn.id === 1) btn.onClick = handleTemplate;
			else if (btn.id === 4) btn.onClick = () => Navigate("report");
			else btn.onClick = handleAddTask;
		});
	}

	const handleNextCurrent = (page) => loadCurrent(page);
	const handleNextPrevious = (page) => loadPrevious(page);

	const dropOptions = {
		onClick: (e) => {
			const op = e.find((o) => o.selected);
			if (!op) setView("current");
			else if (op.text === "Ongoing Tasks") setView("current");
			else if (op.text === "Completed Tasks") setView("previous");
		},
		list: ["Ongoing Tasks", "Completed Tasks"],
	};

	const onSearch = (keyword) => {
		setSearchKeyword(keyword.trim());
	};

	return (
		<div className="Tasks">
			<PageHead
				onSearch={onSearch}
				dropOptions={dropOptions}
				navoption={navoption}
				buttons={btns}
				filter={"Ongoing Tasks"}
			/>
			<div className="CurrentTasks">
				{view === "current" && current.data && (
					<DataTable
						handlePagination={handleNextCurrent}
						reader={TaskReader}
						onClick={onTaskClick}
						flex={flex}
					>
						{current}
					</DataTable>
				)}

				{view === "previous" && previous.data && (
					<DataTable
						handlePagination={handleNextPrevious}
						reader={TaskReader}
						onClick={onTaskClick}
						flex={flex}
					>
						{previous}
					</DataTable>
				)}
			</div>
		</div>
	);
};

export default TasksView;
